module.exports = __webpack_public_path__ + "video_c.7b599bba.png";